import { AxiosResponse } from "axios";
import { useApi } from "../hooks/useApi";

const api = useApi();

export async function getNotifs(): Promise<AxiosResponse<any, any>> {
  try {
    const response = await api.get(`notifications/all-notifs`);
    return response;
  } catch (error) {
    throw new Error(``);
  }
}

export async function markedNotifAsRead(): Promise<number> {
  try {
    const response = await api.put(`notifications/marked-notifs-as-read`);
    return response.status;
  } catch (error) {
    throw new Error(``);
  }
}

export async function deleteNotif(notifId: number) {
  try {
    const response = await api.delete(`notifications/delete${notifId}`);
    return response.status;
  } catch (error) {
    throw new Error(``);
  }
}
